import React from 'react'
import BigButton from '../utils/BigButton/BigButton'
import { isMobileOnly } from 'react-device-detect'
import { COURSES, EXTRAS, estadoCurso } from './cursosEscuela'


const EscuelaForm = ({errors, infoInput, sent, handleSubmit, handleChange, enroledSchoolResponse, isSubmitting}) => {
  // Estado de cada curso calculado según la fecha de hoy (ver cursosEscuela.js)
  const courses = COURSES.map(course => ({
    ...course,
    value: false,
    checked: false,
    state: estadoCurso(course),
  }))
  const extras = EXTRAS.map(extra => ({ ...extra, value: false, checked: false, state: estadoCurso(extra) }))

  const hayCursosAbiertos = courses.some(course => course.state === '')

  return (
    <>
    <div className='inscription-title'>
  
          <h2>{hayCursosAbiertos ? 'COMPLETÁ EL FORMULARIO' : 'INSCRIPCIONES CERRADAS'}</h2>
          {!hayCursosAbiertos && <p className='inscription-closed'>Por el momento no hay cursos con inscripción abierta.</p>}
  </div>  
    {hayCursosAbiertos && (
    <form className= {sent===true ? 'display-none':'inscription-form'}  onSubmit={handleSubmit}>
    <div className='form-first-col'>
    <div className='input-box'>
    <label className='label-black'>Nombre</label>
      <input name="userName" className="light-input" value={infoInput.userName} type="onlyletters" onChange={ e => handleChange(e, 'userName', 'onlyletters', true, 75, 3)} placeholder="Ingresá tu nombre" required={true}/>
      {errors['userName'] && <p className='error'>{errors['userName']}</p>}
    </div>
    <div className='input-box'>
    <label className='label-black'>Apellido</label>
      <input name="userLastName" value={infoInput.userLastName} className='light-input' type="onlyletters" onChange={e => handleChange(e, 'userLastName', 'onlyletters', true, 75, 3)} placeholder='Ingresá tu apellido' required={true}/> 
      {errors['userLastName'] && <p className='error'>{errors['userLastName']}</p>}
    </div>
    <div className='input-box'>
    <label className='label-black'>Organización</label>
      <input name="company" className="light-input" value={infoInput.company} type="text" onChange={e => handleChange(e, 'company', 'text', true, 75, 2)} placeholder="Organización a la que pertenece" required={true}/>
      {errors['company'] && <p className='error'>{errors['company']}</p>}
    </div>
    <div className='input-box'>
    <label className='label-black'>Email</label>
      <input name="email" className="light-input" value={infoInput.email} type="email" onChange={e => handleChange(e, 'email', 'email', true, 75, 8)} placeholder="Ingresá tu mail" required={true}/>
      {errors['email'] && <p className='error'>{errors['email']}</p>}
    </div>
    <div className='input-box'>
    <label className='label-black'>Teléfono</label>
      <input name="phone" className="light-input" value={infoInput.phone} type="number" onChange={e => handleChange(e, 'phone', 'number', true, 15, 7)} placeholder="Ingresá código de área y número sin espacios" required={true}/>
      {errors['phone'] && <p className='error'>{errors['phone']}</p>}
    </div>
    <div className='input-box'>
    <label className='label-black'>DNI</label>
      <input name="dni" className="light-input" value={infoInput.dni} type="number" onChange={e => handleChange(e, 'dni', 'number', true, 15, 7)} placeholder="Ingresá tu número sin puntos" required={true}/>
      {errors['dni'] && <p className='error'>{errors['dni']}</p>}
    </div>
    <div className='input-box'>
    <label className='label-black'>¿Cómo llegaste a la Escuela de Caución?</label>
    <select value={infoInput.howToKnow} required={true} onChange={e => handleChange(e, 'howToKnow', 'text', true)} className="select-box-school">
       <option disabled value="" className='option'>Seleccione una opción</option>
       <option className='option' value="Redes">Redes</option>
        <option className='option' value="Mailing">Mailing</option>
       <option className='option' value="Ejecutivo de AFZ">Ejecutivo de AFZ</option>
       <option className='option' value="Charlas">Charlas</option>
       <option className='option' value="Referido">Referido</option>
      
       <option className='option' value="Otro">Otro</option>
           
    </select>
    </div>
    </div>
    <div className= {sent===true ? 'display-none':(isMobileOnly? "":'selection-box')} >
    <h4 className='subtitle-school-form'>Elegí los cursos a los que querés asistir</h4>
    {courses.map(course => (
      <div className='input-checkbox' key={course.id}>
        <input name={`courses.${course.id}`} 
        value={infoInput[`courses.${course.id}`]} 
        disabled={course.state !== ''}
        checked={
          course.state === "Finalizado" && course.checked ? true : infoInput[`courses.${course.id}`] === 'true' ? true : false
        }
        className='check' type="checkbox" 
        onChange={e => handleChange(e, `courses.${course.id}`, 'checkbox')} /> 
        <p className='school-label'>
          {course.name}
          {course.state && <span className='course-state'> — {course.state}</span>}
        </p>
      </div>
    ))}
    {errors['courses'] && <p className='error'>{errors['courses']}</p>}
      {/* Botones */}
      <div className='inscription-send'>
          <BigButton
            name="CANCELAR"
            className="inscription-cancel-button"
            onClick={() => window.location.href = "/escuela"}
          />
        <BigButton
  type="submit"
  name={isSubmitting ? "ENVIANDO..." : "ENVIAR"} // 👈 UX mejor
  className="inscription-button"
  disabled={isSubmitting} // 👈 CLAVE
/>
        </div>
    {enroledSchoolResponse.error ? <p className={isMobileOnly? 'net-error-mobile':'network-error'}>Se ha producido un error. Inténtelo más tarde.</p> : null}
    </div>
  
    </form>
    )}
    </>
  )
}

export default EscuelaForm